import { toFixed } from "../utils/numbers";
import CountUp from "react-countup";
interface AnimatedNumberProps {
  number: number | string | null;
  decimals?: number;
  animate?: boolean;
  separator?: string;
  prefix?: string;
  suffix?: string;
}
export const AnimatedNumber = ({
  number,
  decimals = 4,
  animate = true,
  separator = "",
  prefix = "",
  suffix = "",
}: AnimatedNumberProps) => {
  return (
    <CountUp
      separator={separator}
      duration={animate ? 0.5 : 0}
      decimals={decimals}
      decimal={"."}
      end={
        separator === ","
          ? (number as number)
          : toFixed(number as number, decimals)
      }
      prefix={prefix}
      suffix={suffix}
    />
  );
};
